import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react"
import { Badge, Button, Card, Col, ListGroup, Modal, Row, Table } from "react-bootstrap"

export default function EncounterSatuSehat({
    getEncounter,
    getNewPatient,
    getNewEncounter,
    getDataNewAppointmentPatient,
    getCondition
}) {

    // const idAppointmentSSP = responsePatient.data.data.map(item => item.id_appointment_ssp);
    // const response = await Promise.all(
    //     idAppointmentSSP.map(idEncounter =>
    //         axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter-id`, {
    //             params: { idEncounter },
    //             headers: {
    //                 Authorization: `${token}`,
    //                 "Content-Type": "application/json"
    //             }
    //         })
    //     )
    // );
    const token = localStorage.getItem("token");

    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const [selectedAppointment, setSelectedAppointment] = useState(null);

    const [listEncounterSSP, setListEncounterSSP] = useState([]);

    const [getDataCondition, setGetDataCondition] = useState([]);
    const [getDataEncounter, setGetDataEncounter] = useState([]);
    const [getDataObservation, setGetDataObservation] = useState([]);

    const handleEncounter = async (idAppointmentSSP) => {
        try {
            console.log("Running Encounter for ID:", idAppointmentSSP);

            const response = await axios.get(
                `https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter-id`,
                {
                    params: { idEncounter: idAppointmentSSP },
                    headers: {
                        Authorization: `${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            setGetDataEncounter(response.data);
            setSelectedAppointment(idAppointmentSSP);
            setModalType("Encounter");
            setShowModal(true);

        } catch (err) {
            console.error("Encounter error:", err);
        }
    };

    const handleCondition = async (idAppointmentSSP) => {
        try {
            const response = await axios.get(
                `https://api-ts.signatureanugerah.co.id/api/satu-sehat/condition-id`,
                {
                    params: { idEncounter: idAppointmentSSP },
                    headers: {
                        Authorization: `${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            setGetDataCondition(response.data);
            setModalType("Condition");
            setSelectedAppointment(idAppointmentSSP);
            setShowModal(true);

        } catch (err) {
            console.error("Condition error:", err);
        }
    };

    const handleObservation = async (idAppointmentSSP) => {
        try {
            const response = await axios.get(
                `https://api-ts.signatureanugerah.co.id/api/satu-sehat/observation-id`,
                {
                    params: { idEncounter: idAppointmentSSP },
                    headers: {
                        Authorization: `${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            setGetDataObservation(response.data);
            setModalType("Observation");
            setSelectedAppointment(idAppointmentSSP);
            setShowModal(true);

        } catch (err) {
            console.error("Condition error:", err);
        }
    };


    useEffect(() => {
        if (!getNewPatient?.data?.data) return;

        const fetchEncounterList = async () => {
            try {
                const idAppointmentSSP = getNewPatient.data.data.map(item => item.id_appointment_ssp);

                const responses = await Promise.all(
                    idAppointmentSSP.map(idEncounter =>
                        axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter-id`, {
                            params: { idEncounter },
                            headers: {
                                Authorization: `${token}`,
                                "Content-Type": "application/json"
                            }
                        })
                    )
                );

                setListEncounterSSP(responses.map(res => res.data));

            } catch (err) {
                console.error("Fetch encounter list error:", err);
            }
        };

        fetchEncounterList();
    }, [getNewPatient]);



    const handleOpenModal = (type, appointment) => {
        setModalType(type);
        setSelectedAppointment(appointment);
        setShowModal(true);
    };


    const handleCloseModal = () => setShowModal(false);

    return (
        <>
            <Card className="mb-4 shadow-sm border-secondary">
                <Card.Header as="h6" className="bg-secondary text-white small">
                    📋 Encounter Info
                </Card.Header>
                <Card.Body>
                    {getDataNewAppointmentPatient.map((item, index) => {
                        const appointment = item; // detail appointment
                        const patient = getNewPatient.data.data[index]; // dari responsePatient
                        return (
                            <>
                                <ListGroup className="mb-3">
                                    <ListGroup.Item key={appointment.id}>
                                        <Row className="align-items-center">
                                            {/* Kolom kiri (teks anamnesa) */}
                                            <Col md={10}>
                                                <div className="d-flex flex-column">
                                                    <span><b>Anamnesa:</b> {appointment.anamnesa}</span>
                                                    <span><b>Anamnesa:</b> {patient.id_appointment_ssp}</span>
                                                </div>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    className="mx-2"
                                                    onClick={() => handleEncounter(patient.id_appointment_ssp)}
                                                >
                                                    Encounter
                                                </Button>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    className="mx-2"
                                                    onClick={() => handleCondition(patient.id_appointment_ssp)}
                                                >
                                                    Condition
                                                </Button>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    className="mx-2"
                                                    onClick={() => handleObservation(patient.id_appointment_ssp)}
                                                >
                                                    Observation
                                                </Button>
                                            </Col>

                                        </Row>
                                    </ListGroup.Item>

                                </ListGroup>
                                <hr />
                            </>
                        );
                    })}
                </Card.Body>
            </Card>


            <Modal show={showModal} onHide={handleCloseModal} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{modalType} - Info</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {selectedAppointment ? (
                        <>
                            {modalType === "Condition" && (
                                <>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>ID Condition</th>
                                                <th>Kategori</th>
                                                <th>Status Klinis</th>
                                                <th>Diagnosis</th>
                                                <th>Tanggal Mulai Gejala</th>
                                                <th>Tanggal Dicatat</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {getDataCondition?.entry?.map((item, idx) => {
                                                const kategoriDisplay =
                                                    item.resource?.category
                                                        ?.map(cat =>
                                                            cat?.coding?.map(code => code?.display)
                                                        )
                                                        ?.flat()
                                                        ?.filter(Boolean);

                                                const statusKlinis =
                                                    item.resource?.clinicalStatus?.coding
                                                        ?.map(code => code?.display)
                                                        ?.filter(Boolean)
                                                        ?.join(", ");

                                                const diagnosis =
                                                    item.resource?.code?.coding
                                                        ?.map(code => code?.display)
                                                        ?.filter(Boolean)
                                                        ?.join(", ");

                                                return (
                                                    <tr key={idx}>
                                                        <td>{idx + 1}</td>
                                                        <td>{item.resource?.id || "-"}</td>

                                                        <td>
                                                            {kategoriDisplay?.length > 0
                                                                ? kategoriDisplay.join(", ")
                                                                : "-"}
                                                        </td>

                                                        <td>{statusKlinis || "-"}</td>

                                                        <td>{diagnosis || "-"}</td>

                                                        <td>
                                                            {item.resource?.onsetDateTime
                                                                ? moment(item.resource.onsetDateTime).format("DD-MM-YYYY HH:mm")
                                                                : "-"}
                                                        </td>

                                                        <td>
                                                            {item.resource?.recordedDate
                                                                ? moment(item.resource.recordedDate).format("DD-MM-YYYY HH:mm")
                                                                : "-"}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </>
                            )}
                            {modalType === "Encounter" && (
                                <>

                                    <p>
                                        <b>ID Encounter Satu Sehat:</b>
                                        {getDataEncounter?.id}
                                    </p>
                                    <p>
                                        <b>Kunjungan:</b>
                                        {getDataEncounter?.class?.display || "-"}
                                    </p>
                                    <p>
                                        <b>Lokasi Kunjungan:</b>{" "}
                                        {getDataEncounter?.location
                                            ?.map(loc => loc.location?.display)
                                            ?.join(", ") || "-"}
                                    </p>
                                    <p>
                                        <b>Petugas Pemeriksa:</b>{" "}
                                        {getDataEncounter?.participant
                                            ?.flatMap(p =>
                                                p.type?.flatMap(t =>
                                                    t.coding?.map(c => c.display)
                                                )
                                            )
                                            ?.filter(Boolean)
                                            ?.join(", ") || "-"}
                                    </p>
                                    <p>
                                        <b>Pemeriksaan dimulai:</b>{" "}
                                        {getDataEncounter?.period?.start
                                            ? moment(getDataEncounter?.period?.start).format("DD-MM-YYYY HH:mm")
                                            : "-"}
                                    </p>
                                    <div>
                                        <b>Riwayat Status:</b>
                                        {getDataEncounter?.statusHistory && getDataEncounter?.statusHistory.length > 0 ? (
                                            getDataEncounter?.statusHistory.map((item, index) => (
                                                <p key={index}>
                                                    Status: {item.status}, Waktu: {item.period?.start ? moment(item.period.start).format("DD-MM-YYYY HH:mm") : "-"}
                                                </p>
                                            ))
                                        ) : (
                                            <p>-</p>
                                        )}
                                    </div>

                                </>
                            )}
                            {modalType === "Observation" && (
                                <>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>ID Condition</th>
                                                <th>Kategori</th>
                                                <th></th>
                                                <th></th>
                                                <th>Tanggal Dicatat</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {getDataObservation?.entry?.map((item, idx) => {
                                                const kategoriDisplay =
                                                    item.resource?.category
                                                        ?.map(cat =>
                                                            cat?.coding?.map(code => code?.display)
                                                        )
                                                        ?.flat()
                                                        ?.filter(Boolean);


                                                const codeCoding =
                                                    item.resource?.code?.coding
                                                        ?.map(code => code?.display)
                                                        ?.filter(Boolean)
                                                        ?.join(", ");

                                                const valueCodeableConcept =
                                                    item.resource?.valueCodeableConcept?.coding
                                                        ?.map(code => code?.display)
                                                        ?.filter(Boolean)
                                                        ?.join(", ");

                                                const valueQuantity =
                                                    item.resource?.valueQuantity?.value


                                                return (
                                                    <tr key={idx}>
                                                        <td>{idx + 1}</td>
                                                        <td>{item.resource?.id || "-"}</td>

                                                        <td>
                                                            {kategoriDisplay?.length > 0
                                                                ? kategoriDisplay.join(", ")
                                                                : "-"}
                                                        </td>


                                                        <td>{codeCoding || "-"}</td>
                                                        <td>
                                                            {`${valueCodeableConcept || ""}  ${valueQuantity ?? ""} ${item.resource?.valueQuantity?.unit ?? ""}`}
                                                        </td>


                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </>
                            )}

                        </>
                    ) : (
                        <p>Loading...</p>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Tutup
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}